<div class="d-flex flex-column gap-3" data-testid="edit-panel">
  <div class="d-flex flex-column gap-1">
    <h3 class="av-section-title m-0">{{ 'backoffice.organizations.edit.title' | translate }}</h3>
    <p class="av-meta m-0">{{ 'backoffice.organizations.edit.hint' | translate }}</p>
  </div>

  @if (!facade.canEdit()) {
    <p class="av-meta m-0" data-testid="edit-restricted">{{ 'backoffice.organizations.edit.restricted' | translate }}</p>
  } @else {
    <form [formGroup]="formGroup" class="edit-grid" (ngSubmit)="submit()">
      <label class="d-flex flex-column gap-1" for="edit-name">
        <span class="av-meta">{{ 'backoffice.organizations.edit.fields.name' | translate }}</span>
        <input id="edit-name" type="text" class="av-field" formControlName="name" />
      </label>

      <label class="d-flex flex-column gap-1" for="edit-domain">
        <span class="av-meta">{{ 'backoffice.organizations.edit.fields.domain' | translate }}</span>
        <input id="edit-domain" type="text" class="av-field" formControlName="domain" />
      </label>

      <label class="d-flex flex-column gap-1" for="edit-nickname">
        <span class="av-meta">{{ 'backoffice.organizations.edit.fields.nickname' | translate }}</span>
        <input id="edit-nickname" type="text" class="av-field" formControlName="avyna_nickname" />
      </label>

      <label class="d-flex flex-column gap-1" for="edit-contact">
        <span class="av-meta">{{ 'backoffice.organizations.edit.fields.contact_email' | translate }}</span>
        <input id="edit-contact" type="email" class="av-field" formControlName="contact_email" />
      </label>

      <label class="d-flex flex-column gap-1" for="edit-currency">
        <span class="av-meta">{{ 'backoffice.organizations.edit.fields.currency' | translate }}</span>
        <input
          id="edit-currency"
          type="text"
          class="av-field"
          maxlength="3"
          formControlName="billing_currency"
        />
      </label>

      <label class="d-flex flex-column gap-1" for="edit-market">
        <span class="av-meta">{{ 'backoffice.organizations.edit.fields.market' | translate }}</span>
        <select id="edit-market" class="av-field" formControlName="market_id">
          <option value="">{{ 'backoffice.organizations.edit.fields.no_market' | translate }}</option>
          @for (market of facade.markets(); track market.id) {
            <option [value]="market.id">{{ market.displayName }}</option>
          }
        </select>
      </label>

      <div class="edit-actions d-flex gap-2">
        <button
          type="submit"
          class="av-btn av-btn-primary"
          [disabled]="!formGroup.valid || facade.isMutating()"
        >
          <mat-icon aria-hidden="true">save</mat-icon>
          {{ 'backoffice.organizations.edit.save' | translate }}
        </button>

        <button type="button" class="av-btn" [disabled]="facade.isMutating()" (click)="reset()">
          {{ 'backoffice.common.actions.reset' | translate }}
        </button>
      </div>
    </form>
  }
</div>
